import PATH from "constants/path";
import {
  am_logo2,
  am_logo3,
  cw_logo2,
  cw_logo3,
  itsumoni_logo2,
  itsumoni_logo3,
} from "assets/img";

const LIST_LOGO = [
  {
    link: PATH.AM,
    img: am_logo3,
    img_mobile: am_logo2,
    alt: "am_logo",
  },
  {
    link: PATH.CLAP,
    img: cw_logo3,
    img_mobile: cw_logo2,
    alt: "cw_logo",
  },
  {
    link: PATH.ITSUMONI,
    img: itsumoni_logo3,
    img_mobile: itsumoni_logo2,
    alt: "itsumoni_logo",
  },
];

const LIST_MENU = [
  {
    path: PATH.TOP,
    name: "TOP",
  },
  {
    path: PATH.FIRST,
    name: "はじめての方へ",
  },
  {
    path: PATH.GUIDE,
    name: "ご利用方法",
  },
  {
    path: PATH.POINT,
    name: "ポイントについて",
  },
  {
    path: PATH.NEWS,
    name: "お知らせ",
  },
  {
    path: PATH.AREA_LIST,
    name: "収録会場",
  },
  {
    path: PATH.QUESTIONS,
    name: "よくあるご質問",
  },
  {
    path: PATH.CONTACT,
    name: "お問い合わせ",
  },
];

const LIST_MENU_MOBILE_AUTH_1 = [
  {
    path: PATH.TOP[0],
    name: "募集中の番組一覧",
  },
  {
    path: PATH.ENTRIES,
    name: "応募中案件",
  },
  {
    path: PATH.MY_POINT,
    name: "現在の保有ポイント",
  },
  {
    path: PATH.PAYMENT,
    name: "支払履歴",
  },
  {
    path: PATH.SETTING,
    name: "会員設定",
  },
];

const LIST_MENU_MOBILE_AUTH_2 = [
  {
    path: PATH.FIRST,
    name: "はじめての方へ",
  },
  {
    path: PATH.GUIDE,
    name: "ご利用方法",
  },
  {
    path: PATH.POINT,
    name: "ポイントについて",
  },
  {
    path: PATH.NEWS,
    name: "お知らせ",
  },
  {
    path: PATH.AREA_LIST,
    name: "収録会場",
  },
  {
    path: PATH.QUESTIONS,
    name: "よくあるご質問",
  },
  {
    path: PATH.CONTACT,
    name: "お問い合わせ",
  },
];

export {
  LIST_LOGO,
  LIST_MENU,
  LIST_MENU_MOBILE_AUTH_1,
  LIST_MENU_MOBILE_AUTH_2,
};
